var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerMapBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9247 0C11.5614 0.0927988 12.2096 0.185598 12.8232 0.394395C16.6318 1.65878 18.9702 4.26874 19.8037 8.20109C20.2552 10.3703 19.8847 12.4814 19.1323 14.523C18.2062 17.0518 16.7939 19.3137 15.15 21.4365C13.7956 23.1997 12.3022 24.8353 10.6816 26.3433C10.2185 26.7725 9.76702 26.7725 9.30397 26.3433C6.71087 23.8957 4.40717 21.2045 2.57811 18.1306C1.47836 16.263 0.575405 14.3026 0.193385 12.1566C-0.45489 8.45629 0.517523 5.24313 3.24954 2.64477C4.8355 1.12519 6.74559 0.278396 8.91037 0.0347995C8.95668 0.0347995 9.01456 0.0115998 9.06086 0C9.68598 0 10.3111 0 10.9247 0ZM9.99855 4.47754C6.94239 4.47754 4.51136 6.91351 4.49978 9.97587C4.49978 13.0498 6.93082 15.4974 9.99855 15.4974C13.0547 15.4974 15.4857 13.0614 15.4973 9.99907C15.4973 6.92511 13.0547 4.47754 9.99855 4.47754Z",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerMapBlue);
export default __webpack_public_path__ + "static/media/marker-map-blue.8e425960e569895ea1a085bf567b373a.svg";
export { ForwardRef as ReactComponent };